// Sereine — panier : quantités, suppression, passage au Duo et codes promo en AJAX.
// Sans JavaScript, le panier reste utilisable (formulaires classiques vers /cart).
(function () {
  document.documentElement.classList.add('sr-js');

  var root = document.querySelector('[data-sr-cart]');
  if (!root || !window.fetch) return;

  var sectionId = root.dataset.sectionId;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var statusEl = root.querySelector('[data-cart-status]');
  var busy = false;
  var barObserver = null;

  function inner() { return root.querySelector('[data-cart-inner]'); }

  function say(msg) { if (statusEl) statusEl.textContent = msg || ''; }

  function showError(msg, selector) {
    var el = root.querySelector(selector || '[data-cart-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  function post(path, body) {
    body.sections = [sectionId];
    body.sections_url = window.location.pathname;
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  function render(json) {
    var html = json.sections && json.sections[sectionId];
    if (html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-inner]');
      if (fresh) inner().replaceWith(fresh);
    }
    var icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function' && typeof json.item_count === 'number') {
      icon.renderCartBubble(json.item_count, false);
    }
    initBar();
  }

  function run(path, body, done) {
    if (busy) return Promise.resolve(null);
    busy = true;
    root.classList.add('is-busy');
    root.setAttribute('aria-busy', 'true');
    return post(path, body)
      .then(function (json) { render(json); say(done); return json; })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Une erreur est survenue. Réessaie dans un instant.';
        showError(msg);
        say(msg);
        return null;
      })
      .finally(function () {
        busy = false;
        root.classList.remove('is-busy');
        root.removeAttribute('aria-busy');
      });
  }

  function changeQty(key, qty) {
    return run('cart/change.js', { id: key, quantity: qty }, qty === 0 ? 'Article retiré du panier.' : 'Quantité mise à jour.');
  }

  function currentCodes() {
    var form = root.querySelector('[data-discount-form]');
    var raw = form ? form.dataset.codes : '';
    return raw ? raw.split(',').filter(Boolean) : [];
  }

  function applyCodes(codes, added) {
    return run('cart/update.js', { discount: codes.join(',') }, '').then(function (json) {
      if (!json || !added) return;
      var found = (json.discount_codes || []).filter(function (d) {
        return d.code.toLowerCase() === added.toLowerCase();
      })[0];
      if (found && found.applicable) {
        say('Code ' + found.code + ' appliqué.');
        return;
      }
      // Code refusé : on le retire puis on explique pourquoi
      var kept = codes.filter(function (c) { return c.toLowerCase() !== added.toLowerCase(); });
      return run('cart/update.js', { discount: kept.join(',') }, '').then(function () {
        var details = root.querySelector('.sr-promo');
        if (details) details.open = true;
        var msg = 'Le code « ' + added + ' » n’est pas valable pour ce panier.';
        showError(msg, '[data-discount-error]');
        say(msg);
      });
    });
  }

  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.closest('[data-qty]').querySelector('[data-qty-input]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
      changeQty(step.dataset.key, next);
      return;
    }
    var remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault();
      changeQty(remove.dataset.key, 0);
      return;
    }
    var drop = e.target.closest('[data-discount-remove]');
    if (drop) {
      var code = drop.dataset.discountRemove.toLowerCase();
      applyCodes(currentCodes().filter(function (c) { return c.toLowerCase() !== code; }), null)
        .then(function () { say('Code retiré.'); });
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) { input.value = input.defaultValue; return; }
    changeQty(input.dataset.key, Math.min(qty, 1));
  });

  root.addEventListener('submit', function (e) {
    var up = e.target.closest('[data-upgrade]');
    if (up) {
      e.preventDefault();
      var updates = {};
      up.querySelectorAll('input[name^="updates["]').forEach(function (i) {
        updates[i.name.slice(8, -1)] = parseInt(i.value, 10);
      });
      run('cart/update.js', { updates: updates }, 'Ton panier contient maintenant l’offre Duo.');
      return;
    }
    var promo = e.target.closest('[data-discount-form]');
    if (promo) {
      e.preventDefault();
      var code = (promo.querySelector('input[name="discount"]').value || '').trim();
      if (!code) return;
      var codes = currentCodes();
      if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) return;
      applyCodes(codes.concat(code), code);
    }
  });

  // Barre de paiement mobile : visible tant que le bouton principal est plus bas dans la page
  function initBar() {
    if (barObserver) barObserver.disconnect();
    var bar = root.querySelector('[data-cart-bar]');
    var main = root.querySelector('[data-checkout-main]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top > 0;
        bar.classList.toggle('is-visible', show);
        if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      });
    });
    barObserver.observe(main);
  }

  initBar();

  // Offre remplacée depuis la fiche produit ou l'accueil (une seule offre par commande)
  try {
    if (sessionStorage.getItem('sr-replaced')) {
      sessionStorage.removeItem('sr-replaced');
      var note = root.querySelector('[data-replaced]');
      if (note) note.hidden = false;
    }
  } catch (err) {}
})();
